module.exports = __webpack_public_path__ + "img/SGS_ISO_9001.68bc508d.jpg";